import axios from 'axios';

export const getAxiosInstance = apiEnv => {
	// Only add prefix for non-prod environments
	const baseURL =
		apiEnv && apiEnv !== 'prod'
			? `https://${apiEnv}.customerservice.api.ashcompanies.com`
			: `https://customerservice.api.ashcompanies.com`;

	const instance = axios.create({
		baseURL,
		withCredentials: true,
	});

	return instance;
};
